import { between, packValidateResults, required } from 'helpers/validators';

export const validate = (data: any, maxCaptureAmount: number) =>
  packValidateResults([
    required(data, ['amount', 'currency']),
    between(data, ['amount'], { min: 2, max: maxCaptureAmount }),
  ]);
